import { Button } from '@factorialco/deprecated-design-system'
import {
  DeleteSpendingPolicyRuleGroupDocument,
  EditSpendingPolicyRuleGroupFragment,
  SpendingPoliciesRulesConfigurationDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

type Props = {
  closeModal: () => void
  ruleGroup: EditSpendingPolicyRuleGroupFragment
  childRuleGroups: EditSpendingPolicyRuleGroupFragment[]
  companyId: string
}

const DeleteRuleGroupModal = ({ closeModal, ruleGroup, companyId, childRuleGroups }: Props) => {
  const [createGroup] = useMutation(DeleteSpendingPolicyRuleGroupDocument, {
    extractorFn: (data) => data.financeMutations.deleteFinanceSpendingPolicySpendingPolicyRuleGroup,
    update(cache) {
      cache.evict({
        id: cache.identify(ruleGroup),
      })
      childRuleGroups.forEach((child) =>
        cache.evict({
          id: cache.identify(child),
        })
      )
    },
    refetchQueries: [SpendingPoliciesRulesConfigurationDocument],
  })
  const handleSubmit = async () => {
    const result = await createGroup({
      variables: {
        id: ruleGroup.id.toString(),
        companyId: companyId,
      },
    })

    const handled = handleResult(result, () => undefined)

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('spending_policies.details.delete_rule.success'),
      })
      closeModal()
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('spending_policies.details.delete_rule.error'),
      })

      closeModal()
    }
    return handled
  }

  return (
    <Modal
      illustration="alert"
      title={i18n.t('spending_policies.details.delete_rule.title')}
      description={i18n.t('spending_policies.details.delete_rule.description')}
      footer={
        <>
          <Button type="secondary" onClick={closeModal}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>{i18n.t(`common.delete`)}</Button>
        </>
      }
      onSubmit={handleSubmit}
      onClose={closeModal}
    ></Modal>
  )
}

export default DeleteRuleGroupModal
